import React, { FunctionComponent } from 'react';
import classNames from '../../../utils/classnames';

export const InputHolder: FunctionComponent<{ isCentered?: boolean }> = ({
    children,
    isCentered,
}) => {
    const classes = classNames('c-input-holder', {
        'input-holder--centered': isCentered,
    });

    return <div className={classes}>{children}</div>;
};

export const InputHolderItem: FunctionComponent<{ isSmall?: boolean }> = ({
    children,
    isSmall,
}) => {
    return (
        <div className={`input-holder__item ${isSmall ? 'input-holder__item--small' : ''}`}>
            {children}
        </div>
    );
};
